<app-pan-button panRole [roles]="['admin']" icon="delete" color="danger" (click)="params.deleteCallback(params.data)"></app-pan-button>
